<div class="recap-item pb-4">
    <p class="recap-label">Linea investimento attuale</p>
    <p class="recap-value">{{ actualInvestmentLineDescription }}</p>

    <p class="recap-label">Costo Operazione</p>
    <p class="recap-value">{{ operationCost }}</p>

    <p class="recap-label">Data Effetto Operazione</p>
    <p class="recap-value">{{ operationEffectDate }}</p>
</div>

<app-assets-table
    [assets]="lineAssets"
    [tableKeys]="tableKeys"
    [isReadOnly]="true"
></app-assets-table>
